import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { ActivityLogs as FulfillmentActivityLogs } from "../../Fulfillment/FulfillmentDetails/WorkflowLogs/ActivityLogs";
import { useCohortDetails } from "../useCohortDetails";

export function ActivityLogs() {
  const { data } = useCohortDetails();
  const { activityId } = useParams<{ activityId: string }>();

  const activities = useMemo(
    () => data?.cohort?.currentWorkflow?.activities ?? [],
    [data?.cohort?.currentWorkflow?.activities]
  );

  return (
    <FulfillmentActivityLogs activities={activities} cohortMode={true} activityId={activityId} />
  );
}
